/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class SiteDetail {
    url?: string; // ecf001
    description?: string; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): SiteDetail {
        if (!data) { return instance; }
        if (data.url != null) {instance.url = data.url; }
        if (data.description != null) {instance.description = data.description; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return SiteDetail.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: SiteDetail) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return SiteDetail.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: SiteDetail): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
